import React, { useState, useEffect } from "react";
import { Steps } from 'antd';
import AboutAthlete from "./about";
import SizeAthlete from "./size";
import PracticeAthlete from "./practiceRecords";
import LifeStyleAthlete from "./lifeStyle";
import HealthStatusAthlete from "./healthStatus";
import ExercisesAthlete from "./exercises";
import ClubsAndEquipmentsAthlete from "./clubsAndEquipments";


export default function AthleteProfile() {
    const [current, setCurrent] = useState(0);



    const Render = (c) => {
        switch (c) {
            case 0: return <AboutAthlete pager={pager} />
            case 1: return <SizeAthlete pager={pager} />
            case 2: return <PracticeAthlete pager={pager}/>
            case 3: return <LifeStyleAthlete pager={pager} />
            case 4: return <HealthStatusAthlete pager={pager} />
            case 5: return <ExercisesAthlete pager={pager} />
            case 6: return <ClubsAndEquipmentsAthlete />
        }
    }


    const pager=(e)=>{
        setCurrent(e)
    }

    return (
        <>
            <Steps
                style={{ fontFamily: "iranSans" }}
                current={current}
                onChange={(e) => setCurrent(e)}
                items={[
                    {
                        title: 'درباره من',
                    },
                    {
                        title: 'سایز اندام ها',
                    },
                    {
                        title: 'سوابق تمرینی',
                    },
                    {
                        title: 'سبک زندگی',
                    },
                    {
                        title: 'وضعیت سلامتی',
                    },
                    {
                        title: 'ورزش ها',
                    },
                    {
                        title: 'باشگاه و تجهیزات',
                    },
                ]}
            />

            <div style={{ width: '100%', marginTop: '25px' }}>
                {Render(current)}
            </div>
        </>
    )
}